var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":`${_vm.imgUrl}/cruiseDetail/pc_ticket_contains.png`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }